import { render, staticRenderFns } from "./NoPic.vue?vue&type=template&id=035ec656&scoped=true"
import script from "./NoPic.vue?vue&type=script&lang=js"
export * from "./NoPic.vue?vue&type=script&lang=js"
import style0 from "./NoPic.vue?vue&type=style&index=0&id=035ec656&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035ec656",
  null
  
)

export default component.exports